import React from 'react';
import { Button } from 'antd';
import s from './s.module.less';

interface ActionButtonsProps {
    showBack?: boolean;
    onNext?: () => void;
    nextDisabled?: boolean;
    nextLabel?: string;
    showNext?: boolean;
    nextLoading?: boolean;
    currentStep?: number;
    onBack?: () => void;
}

export default function ActionButtons({
    showBack = false,
    onNext,
    nextDisabled = false,
    nextLabel = 'Next',
    showNext = true,
    nextLoading = false,
    currentStep = 1,
    onBack,
}: ActionButtonsProps) {
    // 判断是否显示back按钮（移动端且不是第一步）
    const showBackButton = currentStep > 1 && onBack;

    return (
        <div className={`${s.buttonsContainer} ${!showBackButton && !showBack ? s.rightAlign : ''}`}>
            {showBack && (
                <Button
                    className={`${s.exitButton} ${s.desktopOnly}`}
                    onClick={onBack}
                >
                    Back
                </Button>
            )}

            {/* 移动端显示back按钮（除了第一步） */}
            {showBackButton && (
                <Button
                    className={`${s.backButton} ${s.mobileOnly}`}
                    onClick={onBack}
                >
                    Back
                </Button>
            )}

            {showNext && (
                <Button
                    className={`${s.nextButton} ${nextDisabled || nextLoading ? s.disabled : s.enabled}`}
                    onClick={onNext}
                    disabled={nextDisabled || nextLoading}
                    loading={nextLoading}
                >
                    {nextLabel}
                </Button>
            )}
        </div>
    );
}
